import { render, staticRenderFns } from "./AddMateriality.vue?vue&type=template&id=8f5c0328&scoped=true"
import script from "./AddMateriality.vue?vue&type=script&lang=js"
export * from "./AddMateriality.vue?vue&type=script&lang=js"
import style0 from "./AddMateriality.vue?vue&type=style&index=0&id=8f5c0328&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5c0328",
  null
  
)

export default component.exports